<template>

    <v-card>
        <v-card-title><v-icon class="mr-2">mdi-chart-bar</v-icon> Create Widget</v-card-title>

        <v-divider></v-divider>
        
        <v-card-text>
            <v-form ref="createWidgetForm" @submit.prevent :lazy-validation="true" v-model="formValid">
                <v-row>
                    <v-col cols="12">
                        <v-text-field class="mt-6" color="#c42111" label="Report Widget Name" v-model="name" :rules="[validation.required(name, 'Widget Name'), validation.unique(name, $props.reportWidgets, $store.state.user.user_id)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-switch label="Make report widget public" color="#c42111" v-model="widgetPublic" />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="okClick">Ok</v-btn>
        </v-card-actions>
    </v-card>
        
</template>

<script>
export default {
    name: 'CreateWidget',
    props: ['reportName', 'reportWidgets'],
    components: {

    },
    data: () => ({
        formValid: true,
        name: '',
        widgetPublic: true,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            //unique: (widgetName, reportName, reportWidgets, userId) => (!widgetName || !reportWidgets.some(rw => {return (rw.user_id == userId && rw.report_name == reportName && rw.widget_name == widgetName.trim())})) || 'This View Name is already is use for this user. '
            unique: (widgetName, reportWidgets, userId) => (!widgetName || !reportWidgets.some(rw => {return (rw.user_id == userId && rw.widget_name == widgetName.trim())})) || 'This Report Widget Name is already is use for this user. '
        }
    }),

    computed: {

    },

    methods: {
        okClick: function() {
            if(this.$refs.createWidgetForm.validate()) {
                let widgetObj = {
                    name: this.name,
                    public: this.widgetPublic
                }
                this.$emit('ok', widgetObj);
            }
        }

    },

    mounted() {
        this.name = `${this.$props.reportName}`;
    }

  
};
</script>
